import api from '../../api.js';

export const BUTTON_SELECTOR = api.core.ns.selector('btn');
export const BUTTONS_GROUP_SELECTOR = api.core.ns.selector('btns-group');
export const EQUISIZED_BUTTONS_GROUP_SELECTOR = api.core.ns.selector('btns-group--equisized');
